import React, { useContext } from 'react';

import styled from '@emotion/styled';

import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface ReportInformationModalProps {
  label: string;
  description: string;
}

const ReportInformationModal: React.FC<ReportInformationModalProps> = ({
  label,
  description,
}) => {
  const modalContext = useContext(ModalContext);

  return (
    <ModalContainer label={label}>
      <TextArea>{description}</TextArea>
      <SuccessButton onClick={() => modalContext?.setShowModal(false)}>
        Close
      </SuccessButton>
    </ModalContainer>
  );
};

export default ReportInformationModal;

const SuccessButton = styled.button`
  border: none;
  padding: 14px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  border-radius: 4px;
  cursor: pointer;
  background: linear-gradient(
    262.94deg,
    #436db8 9.61%,
    #5b91f5 49.28%,
    #3c80ff 85.91%
  );
`;

const TextArea = styled.div`
  font-weight: 400;
  font-size: 14px;
  margin-top: -10px;

  color: ${({ theme }) => theme.palette.grayTextColor};
`;
